import { render } from "./org-setting.vue?vue&type=template&id=6520f02c&scoped=true"
import script from "./org-setting.vue?vue&type=script&lang=js"
export * from "./org-setting.vue?vue&type=script&lang=js"

import "./org-setting.vue?vue&type=style&index=0&id=6520f02c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6520f02c"]])

export default __exports__